/* src/app/modules/shared/components/reaction/who-reacted-dialog/who-reacted-dialog.component.scss */
.dialog-title {
  font-family: "Play", sans-serif;
  font-weight: 700;
  margin: 0;
}
.dialog-content {
  min-width: 280px;
  max-width: 400px;
}
.reaction-group {
  padding: 12px 0;
}
.reaction-group + .reaction-group {
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}
.reaction-group__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.reaction-group__icon {
  width: 24px;
  height: 24px;
  object-fit: contain;
}
.reaction-group__label {
  font-weight: 600;
  font-size: 14px;
}
.reaction-group__count {
  font-size: 12px;
  color: #777777;
  margin-left: auto;
}
.reaction-group__members {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding-left: 32px;
}
.reaction-group__member {
  display: inline-block;
  font-size: 13px;
  padding: 4px 10px;
  background: rgb(247, 247, 250);
  border-radius: 16px;
  color: rgb(42, 32, 29);
}
/*# sourceMappingURL=who-reacted-dialog.component.css.map */
